import { Component, Input } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { FcinputComponent } from '../fcinput';
/**
 * fc-paginationåé¡µ
 * éç¨åé¡µçå½¢å¼åéé¿åè¡¨ï¼æ¯æ¬¡åªå è½½ä¸ä¸ªé¡µé¢ã
 * å½å è½½/æ¸²ææææ°æ®å°è±è´¹å¾å¤æ¶é´æ¶ã
 * å¯åæ¢é¡µç æµè§æ°æ®ã
 */
@Component({
    // tslint:disable-next-line:component-selector
    selector: 'fc-pagination',
    template: `
    <nz-pagination class="fcpagination" *ngIf="fcSample===undefined||fcSample==='Y'"
        [(nzPageIndex)]="pageIndex"
        [nzTotal]="total"
        [nzSize]="fcSize"
        nzSimple
        [nzShowSizeChanger]="showSizechange"
        [(nzPageSize)]="pageSize"
        [nzShowQuickJumper]="showQjumper"
        [nzShowTotal]="totalTemplate"
        [nzPageSizeOptions]="fcPageSizeOptions"
        (nzPageSizeChange)="pageSizeChange($event)"
        (nzPageIndexChange)="_jumpPage($event)">
    </nz-pagination>
    <nz-pagination class="fcpagination" *ngIf="fcSample&&fcSample==='N'"
    [(nzPageIndex)]="pageIndex"
    [nzTotal]="total"
    [nzSize]="fcSize"
    [nzShowSizeChanger]="showSizechange"
    [(nzPageSize)]="pageSize"
    [nzShowQuickJumper]="showQjumper"
    [nzShowTotal]="totalTemplate"
    [nzPageSizeOptions]="fcPageSizeOptions"
    (nzPageSizeChange)="pageSizeChange($event)"
    (nzPageIndexChange)="_jumpPage($event)">
</nz-pagination>
    <ng-template #totalTemplate let-total>å± {{total}} æ¡</ng-template>
    `,
    styles: [`
    :host ::ng-deep .fcpagination .ant-pagination{
        text-align: center;
    }
    `],
})
export class FcpaginationComponent extends FcinputComponent {
    // æ¯å¦ç®åæ¨¡å¼
    @Input()
    fcSample: string;
    /** æ°æ®æ»æ° */
    @Input()
    fcTotal: string;
    total: number;
    /** å½åæ¾ç¤ºçé¡µæ° */
    @Input()
    fcPageIndex: string;
    pageIndex: number;
    /** æ¯é¡µæ¡æ° */
    @Input()
    fcPageSize: string;
    pageSize: number;
    /** æ¯å¦å¯ä»¥å¿«éè·³è½¬è³æé¡µ */
    @Input()
    fcShowQuickJumper: string;
    showQjumper: boolean;
    /** æ¯å¦å¯ä»¥æ¹ånzPageSize */
    @Input()
    fcShowSizeChanger: string;
    showSizechange: boolean;
    /** æå®æ¯é¡µå¯ä»¥æ¾ç¤ºå¤å°æ¡ */
    @Input()
    fcPageSizeOptions: number[] = [20, 50, 100, 500, 1000];
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-pagination');
        if (this.fcPageIndex === undefined) {
            this.fcPageIndex = '1';
        }
        if (this.fcPageSize === undefined) {
            this.fcPageSize = '10';
        }
        if (this.fcShowSizeChanger === undefined) {
            this.showSizechange = false;
        }
        if (this.fcShowQuickJumper === undefined) {
            this.showQjumper = false;
        }
    }
   /**
    * æ¹åæ¯é¡µæ°ç®
    * @param event äºä»¶åç§°
    */
    pageSizeChange(event: any) {
        this.event('pageSizeChange', event);
    }
   /**
    * è¾å¥è·³è½¬è³æä¸é¡µ
    * @param event äºä»¶
    */
    _jumpPage(event: any) {
        if (this.total !== 0) {
            this.event('jumpPage', event);
        }
    }
    _afterParentInit() {
        if (this.fcShowQuickJumper === 'Y') {
            this.showQjumper = true;
        } else {
            this.showQjumper = false;
        }
        if (this.fcShowSizeChanger === 'Y') {
            this.showSizechange = true;
        } else {
            this.showSizechange = false;
        }
        if (this.fcTotal) {
            try {
                this.total = Number(this.fcTotal || '0');
            } catch (e) {
                this.total = 0;
            }
        } else {
            this.total = 0;
        }
        if (this.fcPageIndex) {
            try {
                this.pageIndex = Number(this.fcPageIndex || '0');
            } catch (e) {
                this.pageIndex = 0;
            }
        } else {
            this.pageIndex = 0;
        }
        if (this.fcPageSize) {
            try {
                this.pageSize = Number(this.fcPageSize || '0');
            } catch (e) {
                this.pageSize = 0;
            }
        }
    }
}


